import gql from 'graphql-tag';
import { appSyncApolloClient } from '../../../helpers/api';

export async function getOrgAppAccess(orgId) {
  const res = await appSyncApolloClient.query({
    fetchPolicy: 'network-only',
    variables: {
      orgId: `org-${orgId}`,
      showSupportUsers: false,
      showInactiveUsers: false,
      showUserType: false,
    },
    query: gql`
      query getOrgInfo(
        $orgId: String!
        $showSupportUsers: Boolean
        $showInactiveUsers: Boolean
        $showUserType: Boolean
      ) {
        getOrgInfo(
          orgId: $orgId
          showSupportUsers: $showSupportUsers
          showInactiveUsers: $showInactiveUsers
          showUserType: $showUserType
        ) {
          appAccess
        }
      }
    `,
  });
  return res.data.getOrgInfo.appAccess;
}